// extracted by mini-css-extract-plugin
module.exports = {"root":"SortAdornment_root__1mDZg","icon":"SortAdornment_icon__1h7UR","up":"SortAdornment_up__34UtY","down":"SortAdornment_down__2phcQ","active":"SortAdornment_active__16p7K"};